import React from 'react'
import {
  CircularProgress,
  List,
  ListItem
} from '@material-ui/core'
import { ClauseCard } from '../Organisms'
import { checkBookmarked, useBookmarkState } from "../Molecules/BookmarkButton"
import { Analytics } from '../../utils'
import { useParams } from '../../utils/Hooks'

const ClauseList = ({ handleClickCard, searchResult }) => {
  const [bookmarks, updateBookmarks] = useBookmarkState("clause")
  const { page, page_size } = useParams()

  if (!searchResult) return <CircularProgress />
  return <List style={{ width: `100%`, padding: 0 }}>
    {searchResult.clauses.map((clause, index) => (
      <ListItem key={clause.clause_id} disableGutters>
        <ClauseCard
          clause={clause}
          handleClickCard={() => {
            Analytics.searchResultClick('clause', index + 1 + (page - 1) * page_size)
            handleClickCard(clause)
          }}
          isBookmarked={checkBookmarked(clause.clause_id, bookmarks)}
          updateBookmarks={updateBookmarks(clause.clause_id)}
        />
      </ListItem>
    ))}
  </List>
}

export default ClauseList